import React from 'react';

import Icon from './';

export default Icon(() => (
    <path d="M12,9.5c-1.4,0-2.5,1.1-2.5,2.5c0,1.4,1.1,2.5,2.5,2.5c1.4,0,2.5-1.1,2.5-2.5c0-0.4-0.1-0.7-0.2-1c-0.2,0.2-0.4,0.4-0.7,0.4 c-0.5,0-0.9-0.4-0.9-0.9c0-0.3,0.1-0.5,0.4-0.7C12.7,9.6,12.3,9.5,12,9.5L12,9.5L12,9.5z M12,7.7c2.4,0,4.4,1.9,4.4,4.3 s-1.9,4.3-4.4,4.3c-2.4,0-4.4-1.9-4.4-4.3S9.6,7.7,12,7.7z M12.1,5.8C5.7,5.8,2,12,2,12s3.7,6.2,10.1,6.2c6.2,0,9.9-6.2,9.9-6.2 S18.2,5.8,12.1,5.8z" />
));
